import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] bg-white flex items-center justify-center px-6 py-24">
      <div className="max-w-lg text-center">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-purple-600 mb-4">Erro 404</p>
        <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-4">Página não encontrada</h1>
        <p className="text-slate-600 text-lg mb-10">
          Este endereço não existe no site da Lukos.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center bg-[#690093] text-white font-bold px-8 py-3 rounded-full hover:bg-[#500070] transition-colors"
          >
            Ir para o início
          </Link>
          <Link
            to="/contato"
            className="inline-flex items-center justify-center border border-slate-200 text-slate-700 font-bold px-8 py-3 rounded-full hover:border-purple-300 hover:text-purple-700 transition-colors"
          >
            Falar com especialista
          </Link>
        </div>
      </div>
    </div>
  );
}
